<template>
  <a-modal
    title="跳转链接"
    :width="900"
    style="top: 20px;"
    :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
    v-model="formData[visibleField]"
    @ok="formData[visibleField]=false"
  >
    <a-spin :spinning="saveLoading">
      <a-row :gutter="8">
        <a-col :span="4">
          <a-tabs
            @change="typeChange"
            :defaultActiveKey="0"
            tabPosition="left"
            :style="{ height: '300px'}"
          >
            <a-tab-pane :tab="type.name" v-for="type in typeList" :key="type.key"></a-tab-pane>
          </a-tabs>
        </a-col>

        <a-col :span="20" class="model-col">
          <a-input-search
            v-model="queryParam.keywords"
            @search="onSearch"
            placeholder="搜索关键字"
            style="width: 100%; margin-bottom: 1rem"
          />
          <a-form-item
            v-if="queryParam.type=='goods'"
            label="选择地区"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-cascader
              :options="cityOptions"
              placeholder="选择地区查找"
              v-model="area_key"
              change-on-select
              @change="onChange"
            />
             <a-button v-if="area_key" style="margin-left:20px" @click="onAreaChange">查找商品</a-button>
             <a-button v-if="area_key.length>0" style="margin-left:20px"  @click="onAreaRemord">重置</a-button>

          </a-form-item>
          <a-table
            :columns="columns"
            :dataSource="contentList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
            <span slot="title1" slot-scope="title,record">{{record.title}}</span>
            <template slot="action" slot-scope="text,record,index">
              <a @click="onSelect(record)" href="javascript:;">选择</a>
            </template>
          </a-table>
        </a-col>
      </a-row>
    </a-spin>
  </a-modal>
</template>
<script>
import { urlPickerList } from '@/api/page'
import { getCityOption } from '@/api/utils'

export default {
  name: 'UrlPicker',
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      cityOptions: [],
      area_key:[],
      saveLoading: false,
      queryParam: {
        type: 'goods',
        area_key: 0
      },
      typeList: [
        {
          name: '商品',
          type: 'goods',
          key: 0
        },
        // {
        //   name: '商品分类',
        //   type: 'goodsCate',
        //   key: 1
        // },
        // {
        //   name: '文章',
        //   type: 'cmsContent',
        //   key: 2
        // },
        {
          name: '门店',
          type: 'shop',
          key: 1
        },
        // {
        //   name: '优惠券',
        //   type: 'coupon',
        //   key: 4
        // },
        // {
        //   name: '砍价',
        //   type: 'kanjia',
        //   key: 5
        // },
        // {
        //   name: '拼团',
        //   type: 'tuan',
        //   key: 6
        // },
        // {
        //   name: '接龙',
        //   type: 'jielong',
        //   key: 7
        // },
        // {
        //   name: '瓜分券',
        //   type: 'guafen',
        //   key: 8
        // },
        // {
        //   name: '抽奖',
        //   type: 'luck',
        //   key: 9
        // },
        // {
        //   name: '链接',
        //   type: 'cmsLink',
        //   key: 10
        // },
        // {
        //   name: '商家',
        //   type: 'business',
        //   key: 11
        // },
        // {
        //   name: '动态',
        //   type: 'dynamic',
        //   key: 12
        // },
        // {
        //   name: '活动',
        //   type: 'activity',
        //   key: 13
        // },
        // {
        //   name: '标签',
        //   type: 'label',
        //   key: 14
        // },
        // {
        //   name: '商家列表',
        //   type: 'businessList',
        //   key: 15
        // }
      ],
      contentList: [],
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '150px'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'title1' }
        },
        {
          title: '选择',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  props: {
    visibleField: {
      type: String | Number,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    field: {
      type: String | Number,
      required: true
    }
  },
  created() {
    let that = this
    that.load()
    that.getCityData()
  },
  methods: {
    onAreaRemord(){
    this.queryParam.area_key=0
    this.area_key=[]
      this.load()

    },
    onAreaChange(){
      this.queryParam.area_key=this.area_key[this.area_key.length-1]
      this.load()
    },
    getCityData() {
      let that = this
      getCityOption({}).then(res => {
        that.cityOptions = res.data
      })
    },
    onChange(value) {
      console.log(value)
    },
    load() {
      let that = this
      urlPickerList(that.queryParam).then(res => {
        that.contentList = res.data
      })
    },
    typeChange(index) {
      let that = this
      that.queryParam.type = that.typeList[index].type
      that.load()
    },
    onSearch() {
      let that = this
      that.load()
    },
    onSelect(record) {
      this.formData[this.field] = record.url
      this.formData['url']['wxmini_url']= record.wxmini_url
      if(record.url.type=='dynamic'){
        this.formData['topic']=record
      } 
      this.formData[this.visibleField] = false

      // console.log(this.formData, record)
      this.$emit('onSelectSuccess', this.formData)
    }
  }
}
</script>
<style>
.model-col >>> .ant-cascader-input {
  width: 250px !important;
}
</style>
